// Capability descriptor for the Capacitor POS and Portal tablet apps.
// HashRouter because the app is served from the capacitor:// protocol.
import browserHost from './browserHost';

const capacitorHost = {
    ...browserHost,
    caps: {
        ...browserHost.caps,
        isPosDevice: true,
        usesHashRouter: true,
        wantsServiceWorker: false,
    },
};

export default capacitorHost;
